
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    calendarPeriod: {
      type: Object,
      default: () => ({}), // TODO: make squads work without needing to pass calendarPeriod in
    },
    initialFixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      fixture: null,
      fixtureHasGoneLive: null,
      fixtureHasEnded: null,
      interval: null,
      refresh: false,
    };
  },
  computed: {
    fixtureToGoLiveInFiveMinutes () {
      const nowFormattedToMatchFixtureDateTime =
        this.$dayjs().format(`YYYY-MM-DDHH:mm:ss`);

      const differenceBetweenNowAndFixtureDateTime = this.$dayjs(
        this.fixture?.fixture?.datetime,
      ).diff(nowFormattedToMatchFixtureDateTime, `minutes`);

      const fixtureToGoLiveInFiveMinutes =
        (differenceBetweenNowAndFixtureDateTime >= 0 &&
          differenceBetweenNowAndFixtureDateTime <= 5) ||
        false;

      return fixtureToGoLiveInFiveMinutes || null;
    },
  },
  watch: {
    fixtureHasGoneLive: {
      immediate: true,
      handler (fixtureHasGoneLive) {
        if (fixtureHasGoneLive) this.refresh = true;
      },
    },
    fixtureHasEnded: {
      immediate: true,
      handler (fixtureHasEnded) {
        if (fixtureHasEnded) this.refresh = false;
      },
    },
    refresh: {
      handler () {
        if (this.refresh) {
          this.interval = setInterval(() => {
            const fixtureHasEnded =
              this.fixture?.fixture?.state?.fixtureGrouping === `Results`;

            this.getLatestResult({
              id: this.fixture?.fixture?.id,
              assignmentFn: ({ response }) => {
                delete this.fixture.fixture;
                this.fixture.fixture = response?.data;
              },
            });

            if (
              fixtureHasEnded ||
              this.isFixtureAbandoned(this.fixture.fixture) ||
              this.isFixturePostponed(this.fixture.fixture)
            ) {
              this.fixtureHasEnded = true;
            }
          }, 20000);
        } else {
          clearInterval(this.interval);
        }
      },
    },
  },
  created () {
    this.fixture = this.objectDeepCopy(this.initialFixture);
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    // INTERFACES:
    // ABSTRACTION BARRIER:
    shouldRenderMatchType (matchType) {
      if (matchType === `Regular` || matchType === null) return null;
      return true;
    },
    getPostGameAnnotation (fixture) {
      switch (fixture.winType?.name) {
      case `AfterExtraTime`:
        return `AET`;
      case `NormalResult`:
        return `FT`;
      default:
        return ``;
      }
    },
    getSquadsFromCalendarPeriod (calendarPeriod) {
      const squads = new Set();
      calendarPeriod?.seasons?.forEach(season => {
        season?.squads?.forEach(squad => {
          if (squad.teamId === this.selectedTeamFromCms?.id) {
            squads.add(squad);
          }
        });
      });
      return squads;
    },
    getMatchTypeAnnotationFromFixture (fixture, squads) {
      let correctSquad = ``;
      squads.forEach(squad => {
        if (squad?.seasonId === fixture?.season.id) {
          correctSquad = squad;
        }
      });
      switch (fixture.fixture?.matchType) {
      case `Cup Short`:
        return `Group ${correctSquad.pool}`;
      case `Cup`:
        return `${fixture?.fixture?.stage?.name}`;
      default:
        return fixture.fixture?.matchType;
      }
    },
  },
};
